import { I18n } from '@aws-amplify/core';
import type { ProcessingStatusType } from '@/types/DataExtraction';
import type {
	GetDataExtractionListRequestDTO,
	GetDataExtractionListResponseDTO
} from '@/core/dto/data-extraction/get-data-extraction-list';

export class GetDataExtractionListMapper {
	constructor(private readonly data: GetDataExtractionListResponseDTO) {}

	static toDTO(values: any): GetDataExtractionListRequestDTO {
		return {
			organization_id: values.organization_id,
			company_id: values.company_id,
			line_id: values.line_id,
			sector_id: values.sector_id,
			report_type_id: values.report_type_id,
			workstation_id: values.workstation_id,
			ergonomy_work_tool_id: values.ergonomy_work_tool_id,
			extraction_data_action_plans: values.extraction_data_action_plans,
			initial_date: values.initial_date,
			final_date: values.final_date,
			extraction_name: values.extraction_name,
			page: values.page,
			limit: values.limit,
			offset: values.offset
		};
	}

	private getStatusLabel(status: ProcessingStatusType): string {
		const options = {
			failed: I18n.get('Failed'),
			pending: I18n.get('Pending'),
			completed: I18n.get('Completed'),
			in_progress: I18n.get('In progress')
		};

		return options[status] || '-';
	}

	private getTranslatedContent(content: string[]): string[] {
		return content.map((item) => I18n.get(item));
	}

	toDomain() {
		return {
			...this.data,
			rows: this.data.rows.map((item) => ({
				...item,
				originalStatus: item.status,
				status: this.getStatusLabel(item.status),
				content: this.getTranslatedContent(item.content)
			}))
		};
	}
}
